"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export function OurMissionSectionProgressLine() {
  const scrollSection = useRef<HTMLDivElement>(null);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(min-width: 768px)");
    const update = () => setIsDesktop(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  const { scrollYProgress } = useScroll({
    target: scrollSection,
    offset: ["start 55%", "start start"],
  });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <div
      ref={scrollSection}
      className="absolute left-8 right-auto top-[10%] h-3/4 w-0.5 bg-white/15 md:left-[2.4375rem]"
    >
      {isDesktop ? (
        <motion.div className="bg-white" style={{ height }} />
      ) : (
        <div className="h-full bg-white" />
      )}
    </div>
  );
}
